import { BaseMemberProps } from "@custom-types/base-types";
import { DateTimeUtils, UiUtils } from "@stellar/utils";
import { MemberInfoActions } from "@pages/member-profile/tab-contents/member-info-tab/member-info-actions";
import { convertProviderIdToProvider, optionalDate } from "@utils/data-display";
import { CopyTextButton } from "@components/copy-text-button";
import { GeneralProfileEvents } from "@utils/track-event/track-event-list";
import { ProfileInfoTab } from "@components/profile-info-tab";

/** Content inside the member information tab */
export function MemberInfo({ member }: BaseMemberProps): React.JSX.Element {
  return (
    <ProfileInfoTab
      contents={[
        {
          label: "ID",
          value: member.identity,
          action: (
            <CopyTextButton
              textToCopy={member.identity}
              successMessage="Member ID copied to clipboard"
              failedMessage="Error: Failed to copy member ID to clipboard"
              trackEventName={{
                name: GeneralProfileEvents.copyToClipboard,
                props: {
                  entityKey: "Id",
                  location: "member profile info tab",
                  target: "USER",
                },
              }}
            />
          ),
          shouldAddDividerBelow: true,
        },
        {
          label: "First Name",
          value: member.firstName ?? UiUtils.DASH,
        },
        {
          label: "Last Name",
          value: member.lastName ?? UiUtils.DASH,
          shouldAddDividerBelow: true,
        },
        {
          label: "Email",
          value: member.email,
          action: (
            <CopyTextButton
              textToCopy={member.email}
              successMessage="Email copied to clipboard"
              failedMessage="Error: Failed to copy email to clipboard"
              trackEventName={{
                name: GeneralProfileEvents.copyToClipboard,
                props: {
                  entityKey: "Email",
                  location: "member profile info tab",
                  target: "USER",
                },
              }}
            />
          ),
        },
        {
          label: "Email Verified",
          value: member.emailVerified ? "Yes" : "No",
        },
        {
          label: "Auth Method",
          value:
            member.authTypeInfo.identifier === "GENERIC_OAUTH"
              ? member.authTypeInfo.name
              : convertProviderIdToProvider(member.authTypeInfo.identifier),
          shouldAddDividerBelow: true,
        },
        {
          label: "Created",
          value: DateTimeUtils.formatDateTimeInUtc({
            date: member.createdAt,
          }),
        },
        {
          label: "Last Login",
          value: optionalDate({ date: member.lastLoginAt }),
          shouldAddDividerBelow: true,
        },
        {
          label: "Job Title",
          value: member.registrationInfo.jobTitle ?? UiUtils.DASH,
        },
        {
          label: "360 Camera",
          value: member.registrationInfo.hasCamera ? "Yes" : "No",
        },
        {
          label: "Country",
          value: member.country ?? UiUtils.DASH,
        },
      ]}
      actionButtons={<MemberInfoActions member={member} />}
    />
  );
}
